import { render, staticRenderFns } from "./_403.vue?vue&type=template&id=63d40950"
import script from "./_403.vue?vue&type=script&lang=js"
export * from "./_403.vue?vue&type=script&lang=js"
import style0 from "./_403.vue?vue&type=style&index=0&id=63d40950&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports